export default __webpack_public_path__ + "static/media/trampapo_01-04.9e904722.jpg";